import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import consultationImg from "../Assets/Images/consultationImg.png";
import faceReadingImg from "../Assets/Images/faceReadingImg.png";
import horoscopeImg from "../Assets/Images/horoscopeImg.png";
import manglikDoshaImg from "../Assets/Images/manglikDoshaImg.png";

const services = [
  {
    title: "Kundli & Birth Chart Analysis",
    description: "Pt. Kamlesh Sharma: Kundli & Birth Chart Analysis at Shri Radha Krishna Mandir, Nagpur.",
    image: consultationImg,
  },
  {
    title: "Vedic Astrology",
    description: "Kundli Analysis by Pt. Kamlesh Sharma at Shri Radha Krishna Mandir, Nagpur.",
    image: faceReadingImg,
  },
  {
    title: "Mahamrityunjay Yagya",
    description: "Kundli & Birth Chart insights from Pt. Kamlesh Sharma (Nagpur).",
    image: horoscopeImg,
  },
  {
    title: "Vastu Consultation",
    description: "Pt. Kamlesh Sharma: Kundli Analysis (Nagpur).",
    image: manglikDoshaImg,
  },
];

const Services = () => {
  const { ref, inView } = useInView({
    triggerOnce: false, // Animation triggers every time it comes into view
    threshold: 0.2, // Adjust how much should be visible before triggering
  });

  return (
    <div className="bg-black text-white py-12 px-6 md:px-16" ref={ref}>
      <div className="container mx-auto flex flex-col md:flex-row items-start gap-12">
        {/* Left - Service Cards Grid */}
        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 gap-8 flex-1"
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
          transition={{ duration: 0.8 }}
        >
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="bg-[#0A2239] p-6 rounded-lg shadow-lg text-center border border-gray-700"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={inView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
            >
              <img src={service.image} alt={service.title} className="w-20 h-20 mx-auto mb-4" />
              <h3 className="text-2xl font-semibold">{service.title}</h3>
              <p className="text-gray-400 mt-2">{service.description}</p>
            </motion.div>
          ))}
        </motion.div>

        {/* Right - Our Services Section */}
        <motion.div
          className="flex-1"
          initial={{ opacity: 0, x: 50 }}
          animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: 50 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-4xl font-bold mt-[100px]">Our Services</h2>
          <p className="text-gray-400 text-lg mt-6">
          Pt. Kamlesh Sharma is a renowned astrologer and spiritual guide based at Shri Radha Krishna Mandir in Sitabuldi, Nagpur.  He offers profound Vedic astrological insights, Kundli analysis, Vastu consultation, and performs powerful rituals like the Mahamrityunjay Yagya.  His deep knowledge and intuitive expertise have helped countless individuals find clarity, prosperity, and spiritual harmony.
          </p>
          <p className="text-gray-400 text-lg mt-6">
          Visit Shri Radha Krishna Mandir and experience the transformative power of astrology and devotion with Pt. Kamlesh Sharma.
          </p>

          {/* More Services Button */}
          <motion.div
            className="mt-6"
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.8 }}
          >
            <a href="/about" className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-full text-lg font-semibold inline-block">
              More Service
            </a>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default Services;
